import React from 'react';
import PropTypes from 'prop-types';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  FDDialogActions, FDDialogContent, FDDialogTitle, FDList, FDListItem, FDListItemText, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { stepMap } from '../..';

const Intro = ({ changeState }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <>
      <FDDialogTitle value={'Install an Authentication App'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
          <FDList>
            <FDListItem>
              <FDListItemText primaryText={'1. On your iPhone or Android device, access the App Store or Google Play Store.'} />
            </FDListItem>
            <FDListItem>
              <FDListItemText primaryText={'2. Search for GOOGLE AUTHENTICATOR or AUTHY or similar authentication app.'} />
            </FDListItem>
            <FDListItem>
              <FDListItemText primaryText={'3. Tap the app and download to install it.'} />
            </FDListItem>
          </FDList>
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Intro continue');
            changeState(stepMap.captureQRCode);
          }}
          test={'security-settings-button-authenticatorApp-register-modal-start'}
        />
      </FDDialogActions>
    </>);
};

Intro.propTypes = {
  changeState: PropTypes.func.isRequired,
};

export default Intro;
